/** https://www.npmjs.com/package/countdown **/
import countdown from "./countdown";

document.addEventListener("DOMContentLoaded", eggoTimer);


async function eggoTimer() {
    const timer = document.querySelector("#announcement-countdown");
    let additionalSeconds = 0;
    if (!timer) return;
    const toDate = timer.dataset.futureDate;
    if (toDate === "") return;
    const parsedToDate = simpleDateParse(toDate);

    const fromDate = await fetch("https://app.eggo.si/api/get-time").then(res => res.json());
    const parsedFromDate = new Date(fromDate.year, fromDate.month, fromDate.day, fromDate.hour, fromDate.minute, fromDate.seconds);
    const format = {
        day: timer.dataset.dateDay,
        hour: timer.dataset.dateHour,
        minute: timer.dataset.dateMinute,
        second: timer.dataset.dateSecond
    };
    const status = timeLoop(timer, parsedFromDate, parsedToDate, additionalSeconds, format);
    additionalSeconds++

    if (status) {
        timer.classList.add("loaded");
        const intervalTimer = setInterval(() => {
            timeLoop(timer, parsedFromDate, parsedToDate, additionalSeconds, format, intervalTimer);
            additionalSeconds++;
        }, 1000)
    }


}

function timeLoop(timer, fromDate, toDate, additionalSeconds, format, interval = null) {
    const fromDateNew = addAdditionalSeconds(fromDate, additionalSeconds);
    const countdownValue = countdown(fromDateNew, toDate);
    if (countdownValue.value < 0) {
        if (interval) clearInterval(interval);
        timer.classList.remove("loaded");
        return false;
    } else {
        timer.innerHTML = `
        ${timeBlock(countdownValue.days, format.day)}
        ${seperator()}
        ${timeBlock(countdownValue.hours, format.hour)}
        ${seperator()}
        ${timeBlock(countdownValue.minutes, format.minute)}
        ${seperator()}
        ${timeBlock(countdownValue.seconds, format.second)}
    `;
    }
    return true;
}

function addAdditionalSeconds(date, deductSeconds) {
    const time = date.getTime() + deductSeconds * 1000;
    return new Date(time);
}

function timeBlock(time, unit) {
    time = time.toString().length === 1 ? "0" + time : time;
    return `<span class='countdown-block'><span class='countdown-block__value'>${time}</span><span class='countdown-block__label'>${unit}</span></span>`;
}

function seperator() {
    return `<span class='countdown-block__separator'>:</span>`;
}

function simpleDateParse(date) {
    const [DMY, HIS] = date.split(" ");
    const [D, M, Y] = DMY.split(".");
    const [H, I, S] = HIS.split(":");

    return new Date(parseInt(Y), parseInt(M), parseInt(D), parseInt(H), parseInt(I), parseInt(S));
}